import { RadioTower } from "lucide-react";

export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <div className={`brand ${compact ? "brand--compact" : ""}`}>
      <span className="brand__mark" aria-hidden="true">
        <RadioTower size={compact ? 17 : 21} strokeWidth={2.2} />
      </span>
      <span className="brand__name">
        Update<span>Relay</span>
      </span>
    </div>
  );
}
